import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';

import { StepMessage } from '../../shared/StepMessage';

const Payment = ({ request }: { request: RequestWithRelations }) => {
  return (
    <BrandRequestMainContent>
      <Stack gap="1.5rem">
        <ClientStepper request={request} />

        <StepMessage
          message={
            <Trans id="store.request.payment.text">
              The client has been notified to proceed to the payment.
            </Trans>
          }
        />

        <ClientArticlesList request={request} showPrice showArticleComment />
      </Stack>
    </BrandRequestMainContent>
  );
};

export default Payment;
